import type { MessageCatalog } from "./en.js";

export const koMessages = {
  "common.none": "없음",
  "common.missing": "누락",
  "common.ready": "준비됨",
  "common.unknown": "알 수 없음",
  "common.untitled": "(제목 없음)",
  "common.yes": "예",
  "common.no": "아니요",
  "command.exit.description": "현재 세션 종료",
  "command.help.description": "사용 가능한 명령 보기",
  "command.status.description": "현재 프로젝트 상태 보기",
  "command.export.description": "현재 대화를 Markdown으로 내보내기",
  "command.help.header": "사용 가능한 명령:",
  "command.help.footer": "그 밖의 입력은 Kitty에 직접 전달됩니다.",
  "tui.idle": "대기",
  "tui.running": "실행 중",
  "tui.thinkingElapsed": "생각 중 {elapsed}",
  "tui.background": "백그라운드",
  "tui.failed": "실패",
  "tui.waiting": "대기 중",
  "tui.backgroundRunning": "백그라운드 실행 중",
  "tui.model": "모델",
  "tui.context": "컨텍스트",
  "tui.commands": "명령",
  "tui.commandPalette": "팔레트",
  "tui.inputPlaceholder": "메시지 입력",
  "tui.commandQuery": "명령",
  "tui.commandQueryPlaceholder": "이름 또는 설명 입력",
  "tui.commandNoMatches": "일치하는 명령이 없습니다",
  "tui.history": "기록",
  "tui.historyPlaceholder": "키워드 입력",
  "tui.historyNoMatches": "일치하는 입력이 없습니다",
  "tui.scrollHelp": "↑↓ 스크롤  ·  Esc 닫기",
  "tui.newContent": "새 내용 있음 · End로 맨 아래 이동",
  "tui.newContentRows": "새 줄 {count}개 · End로 맨 아래 이동",
  "tui.copySuccess": "선택한 내용을 복사했습니다.",
  "tui.copyUnavailable": "복사 실패: 이 터미널에서 클립보드를 사용할 수 없습니다.",
  "tui.copyFailed": "복사 실패: {error}",
  "tui.draftBusy": "SQLite가 사용 중이어서 초안을 아직 전송할 수 없습니다. 다시 시도하세요.",
  "tui.externalEditorFailed": "외부 편집기 실패: {error}",
  "tui.authorTip": "마음껏 탐험하고 즐기세요!",
  "tui.tool.created": "생성",
  "tui.tool.updated": "업데이트",
  "tui.tool.read": "읽음",
  "tui.tool.ran": "실행",
  "tui.tool.updatedPlan": "계획 업데이트",
  "tui.newSession": "새 세션",
  "tui.sessionControls": "↑↓ 선택  ·  Enter 열기  ·  Esc 종료",
  "tui.unnamedSession": "제목 없는 세션 {id}",
  "tui.time.now": "방금",
  "tui.time.minutes": "{count}분 전",
  "tui.time.hours": "{count}시간 전",
  "tui.time.days": "{count}일 전",
  "tui.time.weeks": "{count}주 전",
  "tui.time.months": "{count}개월 전",
  "tui.time.years": "{count}년 전",
  "tui.help.discovery": "검색",
  "tui.help.input": "입력",
  "tui.help.navigation": "탐색",
  "tui.help.commandCompletion": "명령 자동 완성",
  "tui.help.commandPalette": "명령 팔레트",
  "tui.help.historySearch": "입력 기록 검색",
  "tui.help.shortcuts": "키보드 도움말",
  "tui.help.submit": "전송",
  "tui.help.newline": "줄바꿈",
  "tui.help.lineBounds": "줄 시작/끝",
  "tui.help.killYank": "줄 끝/시작/이전 단어 잘라내기 및 붙여넣기",
  "tui.help.externalEditor": "외부 편집기",
  "tui.help.historyNavigation": "여러 줄 입력 또는 기록에서 이동",
  "tui.help.wordMovement": "단어 단위 이동",
  "tui.help.menuConfirm": "메뉴 자동 완성/확인",
  "tui.help.closeOverlay": "최상위 패널 닫기",
  "tui.help.interrupt": "현재 실행 중단",
  "tui.help.redraw": "터미널 다시 그리기",
  "interaction.steerAccepted": "현재 대화를 안내했습니다.",
  "interaction.interrupted": "현재 턴을 중단했습니다. 계속 입력할 수 있습니다.",
  "interaction.interrupting": "중단 처리 중입니다.",
  "interaction.exitHint": "이 세션은 자동으로 종료되지 않습니다. quit 또는 q를 입력하세요.",
  "interaction.sessionSaved": "세션을 저장했습니다.",
  "interaction.turnInterrupted": "턴을 중단했습니다. 대화를 계속할 수 있습니다.",
  "interaction.requestFailed": "요청에 실패했습니다.",
  "interaction.sessionAlive": "요청에 실패했지만 세션은 계속 사용할 수 있습니다.",
  "interaction.inputRejected": "입력을 받지 못했습니다: {error}",
  "interaction.recoveredTurns": "중단된 턴 상태 {count}개를 복구했습니다. 복구 가능한 작업은 영구 세션과 도구 사실에서 계속됩니다.",
  "interaction.inspectProcessesFailed": "실행 중인 백그라운드 프로세스를 확인하지 못했습니다: {error}",
  "interaction.runningProcesses": "실행 중인 프로세스가 있습니다. 지금 종료하면 모두 중지됩니다.",
  "interaction.killProcessesPrompt": "실행 중인 모든 프로세스를 중지하고 종료할까요? [y/N] ",
  "interaction.exitCancelled": "종료를 취소했습니다. 백그라운드 프로세스는 계속 실행됩니다.",
  "interaction.stopProcessesPartial": "일부 백그라운드 프로세스를 중지하지 못했습니다. 실행 중: {pids}. 종료를 취소했습니다.",
  "interaction.stoppedProcesses": "백그라운드 프로세스 {count}개를 중지했습니다.",
  "interaction.stopProcessesFailed": "백그라운드 프로세스 중지 실패: {error}",
  "interaction.forcedStopPartial": "일부 실행 중 프로세스를 중지하지 못했습니다: {pids}.",
  "interaction.forcedStopped": "실행 중 프로세스 {count}개를 중지했습니다.",
  "interaction.forcedStopFailed": "실행 중 프로세스 중지 실패: {error}",
  "local.noMessages": "현재 세션에 아직 메시지가 없습니다.",
  "local.conversationExported": "현재 대화를 내보냈습니다: {path}",
  "scene.headline.blockedOne": "주의가 필요한 백그라운드 작업이 1개 있습니다.",
  "scene.headline.blockedMany": "주의가 필요한 백그라운드 작업이 {count}개 있습니다.",
  "scene.headline.watchOne": "아직 출력이 없는 백그라운드 작업이 1개 실행 중입니다.",
  "scene.headline.watchMany": "아직 출력이 없는 백그라운드 작업이 {count}개 실행 중입니다.",
  "scene.headline.activeOne": "백그라운드 작업이 1개 실행 중입니다.",
  "scene.headline.activeMany": "백그라운드 작업이 {count}개 실행 중입니다.",
  "scene.headline.noSession": "아직 시작된 세션이 없습니다.",
  "scene.headline.ready": "최근 세션이 준비되었습니다.",
  "scene.noFocus": "현재 초점이 아직 없습니다.",
  "scene.next.wait": "활성 작업을 기다리거나 `kitty status` / `kitty background`으로 확인하세요.",
  "scene.next.start": "`kitty`로 세션을 시작하세요.",
  "scene.next.continue": "최근 세션에서 계속하세요.",
  "scene.noBlockers": "표시된 차단 요소가 없습니다.",
  "scene.contextUnmeasured": "컨텍스트를 아직 측정하지 않았습니다",
  "scene.providerUsageUnavailable": "provider usage를 사용할 수 없습니다",
  "scene.noModelRequest": "모델 요청 기록이 없습니다",
  "scene.noToolProjection": "도구 출력에 아직 투영이 필요하지 않습니다",
  "scene.recoveryOne": "복구 확인이 필요한 백그라운드 작업이 1개 있습니다.",
  "scene.recoveryMany": "복구 확인이 필요한 백그라운드 작업이 {count}개 있습니다.",
  "scene.wakeOne": "깨우기 신호가 1개 기록되었습니다.",
  "scene.wakeMany": "깨우기 신호가 {count}개 기록되었습니다.",
  "scene.recoveryClear": "복구 상태가 정상입니다.",
  "scene.noSkills": "이 프로젝트에서 런타임 skill을 찾지 못했습니다.",
  "scene.skillIssues": "이 skill을 사용하기 전에 문제를 확인하세요.",
  "scene.skillsReady": "skills가 준비되었습니다. 필요할 때만 전체 내용을 불러오세요.",
  "scene.noBackground": "실행 중인 백그라운드 작업이 없습니다.",
  "scene.backgroundRunning": "백그라운드 작업이 실행 중입니다. 기다리거나 최신 출력을 확인하세요.",
  "scene.executionState": "실행 상태: {status}.",
  "scene.executionTask": "{kind} 작업",
  "scene.taskActive": "작업이 실행 중입니다.",
  "scene.cost.context": "컨텍스트 {percent}%{compressed}",
  "scene.cost.compressed": ", 압축됨",
  "scene.cost.stable": "안정 접두부 {ratio}",
  "scene.cost.totalTokens": "{count} tokens",
  "scene.cost.cacheUnknown": "캐시 알 수 없음",
  "scene.cost.cached": "캐시 {count}",
  "scene.cost.cacheHit": "적중률 {percent}%",
  "scene.tool.recent": "최근 {count}개",
  "scene.tool.saved": "예상 {count} tokens 절약",
  "scene.tool.recoverable": "복구 가능 {count}개",
  "scene.tool.degraded": "성능 저하 {count}개",
  "scene.execution.backgroundBlocked": "`kitty background read {id}`로 출력을 확인하거나 `kitty background stop {id}`로 중지하세요.",
  "scene.execution.backgroundWatch": "첫 출력을 기다리거나 `kitty background read {id}`로 확인하세요.",
  "scene.execution.backgroundActive": "`kitty background read {id}`로 확인하고 지금 결과가 필요하면 `kitty background wait {id}`를 사용하세요.",
  "scene.execution.inspectBeforeContinue": "계속하기 전에 {kind} {id}를 확인하세요.",
  "scene.execution.watch": "{kind} {id}의 출력 또는 기한을 확인하세요.",
  "scene.kind.background": "백그라운드",
  "status.project": "프로젝트",
  "status.state": "상태 디렉터리",
  "status.currentScene": "현재 상황",
  "status.configuration": "현재 설정",
  "status.thinking": "사고 모드",
  "status.reasoningEffort": "추론 강도",
  "status.extensions": "활성 확장",
  "status.recentEvents": "최근 이벤트",
  "status.now": "현재",
  "status.focus": "초점",
  "status.next": "다음",
  "status.blocked": "차단",
  "status.background": "백그라운드",
  "status.skills": "Skills",
  "status.cost": "비용",
  "status.toolOutput": "도구 출력",
  "status.recovery": "복구",
  "status.runtimeFacts": "런타임 사실",
  "status.session": "세션",
  "status.sessions": "세션",
  "status.contextBudget": "컨텍스트 예산",
  "status.workset": "작업 집합",
  "status.modelCache": "모델 캐시",
  "status.projectOrientation": "프로젝트 파악",
  "status.executions": "실행",
  "status.wakeSignals": "깨우기 신호",
  "status.taskFacts": "작업 사실",
  "status.latestSession": "최근 세션",
  "status.projectFacts": "프로젝트 사실",
  "status.hotspots": "컨텍스트 예산 핫스팟",
  "status.sources": "컨텍스트 예산 소스",
  "status.cacheLayout": "캐시 구성",
  "status.modelRequests": "최근 모델 요청",
  "status.toolOutputs": "최근 도구 출력",
  "status.recentExecutions": "최근 실행",
  "status.skillsAttention": "주의가 필요한 Skills",
  "status.files": "파일 {count}개",
  "status.readyCount": "{ready}/{total} 준비됨",
  "status.activeTotal": "활성 {active} / 전체 {total}",
  "status.messageCount": "메시지 {count}개",
  "status.compressed": "압축={mode}",
  "status.notCompressed": "압축=아니요",
  "status.usageUnavailable": "usage 사용 불가",
  "status.usageProviderUnavailable": "provider에서 usage를 제공하지 않음",
  "common.ok": "정상",
  "common.present": "설정됨",
  "common.unresolved": "해결되지 않음",
  "common.custom": "사용자 지정",
  "common.changed": "변경됨",
  "common.clean": "변경 없음",
  "common.unavailable": "사용 불가",
  "common.notReady": "준비되지 않음",
  "common.failed": "실패",
  "common.tracked": "추적됨",
  "common.interrupted": "중단됨",
  "cli.program.description": "Kitty - 지속 실행을 위한 에이전트.",
  "cli.version.description": "현재 Kitty 버전을 출력합니다.",
  "cli.option.model": "설정된 모델 덮어쓰기",
  "cli.option.cwd": "이번 실행의 작업 디렉터리",
  "cli.option.json": "구조화된 JSON을 출력합니다.",
  "cli.option.timeoutMs": "대기 제한 시간(밀리초).",
  "cli.option.readMode": "읽기 모드: summary, tail 또는 full.",
  "cli.option.tail": "tail 모드에서 읽을 출력 줄 수.",
  "cli.argument.promptOptional": "선택적 일회성 작업. 생략하면 대화형 모드를 엽니다.",
  "cli.argument.promptRequired": "보낼 작업",
  "cli.argument.sessionIdOptional": "세션 ID. 기본값은 최근 세션입니다.",
  "cli.argument.backgroundAction": "선택 작업: list, read, wait, stop",
  "cli.argument.backgroundId": "read, wait 또는 stop에 사용할 백그라운드 실행 ID",
  "cli.argument.changeIdOptional": "선택적 변경 ID",
  "cli.command.background": "백그라운드 실행을 검사, 읽기, 대기 또는 중지합니다.",
  "cli.command.start": "프로젝트를 초기화하고 Kitty 로컬 콘솔을 엽니다.",
  "cli.command.undo": "최근 또는 지정 ID 변경을 되돌립니다.",
  "cli.command.status": "현재 프로젝트 런타임 상태를 표시합니다.",
  "cli.command.run": "새 세션에서 일회성 작업을 실행합니다.",
  "cli.command.resume": "최근 또는 지정 세션을 대화형 모드로 재개합니다.",
  "cli.command.telegram": "Telegram 개인 채팅 제어를 제공합니다.",
  "cli.command.telegramServe": "롱 폴링으로 Telegram 개인 채팅 서비스를 실행합니다.",
  "cli.command.weixin": "Weixin iLink 개인 채팅에서 Kitty를 제어합니다.",
  "cli.command.weixinLogin": "QR 코드로 Weixin iLink에 로그인합니다.",
  "cli.command.weixinServe": "Weixin iLink 개인 채팅 서비스를 실행합니다.",
  "cli.command.weixinLogout": "Weixin iLink 로그인 상태를 지웁니다.",
  "cli.run.incomplete": "실행이 완료되지 않았습니다.",
  "cli.background.idRequired": "background {action}에는 실행 ID가 필요합니다.",
  "cli.background.unknownAction": "알 수 없는 background 작업: {action}. list, read, wait 또는 stop을 사용하세요.",
  "cli.background.none": "백그라운드 실행 기록이 없습니다.",
  "cli.sessions.none": "저장된 세션이 없습니다.",
  "cli.start.ready": "Kitty 로컬 콘솔이 준비되었습니다.",
  "cli.start.browserFailed": "브라우저를 자동으로 열 수 없습니다. 위 URL을 직접 여세요.",
  "cli.undo.done": "{id}를 되돌렸습니다",
  "cli.tui.requiresTty": "kitty에는 대화형 TTY가 필요합니다. 일회성 실행에는 kitty run <prompt>를 사용하세요.",
  "cli.tui.unavailable": "TUI 진입점을 사용할 수 없습니다. npm.cmd run build를 실행한 뒤 다시 시도하세요. 원인: {error}",
  "cli.sessionPicker.prompt": "세션을 선택하세요(번호, 새 세션은 0): ",
  "cli.sessionPicker.recent": "최근 세션",
  "cli.sessionPicker.new": "새 세션",
  "cli.sessionPicker.invalid": "잘못된 선택입니다. 다시 입력하세요.",
  "cli.sessionPicker.invalidRange": "목록의 번호 또는 새 세션을 위한 0을 입력하세요.",
  "cli.intro.session": "세션",
  "cli.intro.cwd": "작업 디렉터리",
  "cli.intro.tools": "도구",
  "cli.intro.commands": "명령",
  "preflight.project": "프로젝트",
  "preflight.state": "상태 디렉터리",
  "preflight.file": "파일",
  "preflight.envKeys": "환경 변수",
  "preflight.activeExpected": "활성 {active} / 예상 {expected}",
  "preflight.missingKeys": "누락 키",
  "preflight.provider": "provider",
  "preflight.model": "모델",
  "preflight.baseUrl": "기본 URL",
  "preflight.providerPreset": "provider 프리셋",
  "preflight.providerProfile": "provider 프로필",
  "preflight.modelProfile": "모델 프로필",
  "preflight.wireApi": "통신 API",
  "preflight.catalog": "카탈로그",
  "preflight.apiKey": "API 키",
  "preflight.status": "사전 검사",
  "preflight.next": "다음",
  "preflight.runInit": "`kitty start`를 실행해 로컬 .kitty 파일을 만들고 콘솔 열기",
  "preflight.fillMissing": "`.kitty/.env`를 열어 누락 키 채우기",
  "preflight.setApiKey": "`.kitty/.env`에 `KITTY_API_KEY` 설정하기",
  "preflight.startKitty": "`kitty`로 Kitty 시작하기",
  "preflight.reviewEnv": "`.kitty/.env` 검토하기",
  "status.totalSkipped": "전체 {total}, 건너뜀 {skipped}",
  "status.blockedCount": "차단 {count}",
  "status.label.reason": "이유",
  "status.label.messages": "메시지",
  "status.label.directories": "디렉터리",
  "status.label.scripts": "스크립트",
  "status.label.tests": "테스트",
  "status.label.git": "git",
  "status.label.read": "읽기",
  "status.label.changed": "변경",
  "status.label.lastTool": "마지막 도구",
  "status.label.change": "변경 ID",
  "status.label.chars": "문자",
  "status.label.lines": "줄",
  "status.label.stable": "안정 접두부",
  "status.label.stableChars": "안정 문자 수",
  "status.label.tail": "가변 꼬리",
  "status.label.tailChars": "꼬리 문자 수",
  "status.label.stableRatio": "안정 비율",
  "status.label.stableSources": "안정 소스",
  "status.label.volatileSources": "가변 소스",
  "status.label.provider": "provider",
  "status.label.duration": "소요 시간",
  "status.label.usage": "사용량",
  "status.label.kind": "종류",
  "status.label.mode": "모드",
  "status.label.raw": "원본 tokens",
  "status.label.projected": "투영 tokens",
  "status.label.saved": "절약 tokens",
  "status.label.savedRatio": "절약률",
  "status.label.recoverable": "복구 가능",
  "status.label.degraded": "성능 저하",
  "status.label.fullOutput": "전체 출력",
  "status.label.risk": "위험",
  "status.label.summary": "요약",
  "status.label.next": "다음",
  "status.label.lastOutput": "마지막 출력",
  "status.label.actor": "실행자",
  "status.label.expected": "예상 출력",
  "status.label.resources": "리소스",
  "status.label.dependencies": "의존성",
  "status.label.host": "호스트",
  "status.label.message": "메시지",
  "status.label.error": "오류",
  "status.label.state": "상태",
  "status.label.issues": "문제",
  "status.label.cached": "캐시됨",
  "status.label.cacheMiss": "캐시 미스",
  "status.label.cacheHit": "적중률",
  "status.label.input": "입력 tokens",
  "status.label.output": "출력 tokens",
  "status.label.reasoning": "추론 tokens",
  "status.label.cacheRead": "캐시 읽기",
  "status.label.cacheWrite": "캐시 쓰기",
  "runtime.channel.agent": "Kitty",
  "runtime.channel.system": "시스템",
  "runtime.reasoning": "생각",
  "runtime.tool": "도구",
  "runtime.result": "결과",
  "runtime.preview": "미리보기",
  "runtime.content": "내용",
  "runtime.toolFailed": "도구 실패: {name}",
  "runtime.thinking": "생각 중",
  "telegram.help.help": "/help            Telegram 사용 도움말 표시",
  "telegram.help.stop": "/stop            봇 서비스를 종료하지 않고 현재 Telegram 작업 중지",
  "telegram.help.status": "/status          현재 실행 상태 표시",
  "telegram.help.files": "파일 사용법:",
  "telegram.help.sendFile": "- 개인 채팅으로 파일을 직접 보내세요. Kitty가 다운로드해 현재 세션에 첨부합니다.",
  "telegram.help.analyzeFile": "- 방금 보낸 파일을 분석하거나 지정 파일을 돌려달라고 Kitty에 요청할 수 있습니다.",
  "telegram.help.stopTask": "- 현재 작업을 중지하려면 /stop을 사용하세요.",
  "telegram.help.note": "터미널 전용 명령은 Telegram에서 사용할 수 없습니다.",
  "telegram.blockedLocal": "이 명령은 Telegram에서 사용할 수 없습니다. /help로 사용 가능한 명령을 확인하세요.",
  "telegram.prefix.warning": "경고",
  "telegram.prefix.error": "오류",
  "telegram.prefix.interrupt": "중단",
  "telegram.stopConfirmed": "현재 Telegram 작업을 중지하는 중입니다. 봇은 온라인 상태로 다음 요청을 기다립니다.",
  "telegram.noTask": "현재 실행 중인 Telegram 작업이 없습니다.",
  "remote.command.stop.description": "현재 작업을 중지하고 서비스는 온라인으로 유지",
  "remote.command.new.description": "이전 기록을 유지하고 새 세션 시작",
  "remote.stopConfirmed": "현재 작업을 중지하고 있습니다. 다음 요청을 위해 서비스는 온라인 상태를 유지합니다.",
  "remote.noTask": "현재 실행 중인 작업이 없습니다.",
  "remote.newConfirmed": "새 세션이 준비되었습니다. 이전 세션은 계속 저장됩니다.",
  "remote.noSession": "이 채팅에는 아직 세션이 없습니다.",
  "remote.blockedCommand": "여기서는 이 명령을 사용할 수 없습니다. /help에서 현재 명령을 확인하세요.",
  "telegram.tokenMissing": "Telegram token이 없습니다. KITTY_TELEGRAM_TOKEN 또는 config.telegram.token을 설정하세요.",
  "telegram.whitelistEmpty": "Telegram 허용 목록이 비어 있습니다. KITTY_TELEGRAM_ALLOWED_USER_IDS 또는 config.telegram.allowedUserIds를 설정하세요.",
  "weixin.notLoggedIn": "Weixin에 로그인하지 않았습니다. 먼저 kitty weixin login을 실행하세요.",
  "weixin.whitelistEmpty": "Weixin 허용 목록이 비어 있습니다. KITTY_WEIXIN_ALLOWED_USER_IDS를 설정하세요.",
  "weixin.qrCode": "[weixin] Weixin에서 열거나 스캔하세요: {value}",
  "weixin.scanned": "[weixin] QR 코드를 스캔했습니다. 확인을 기다리는 중입니다.",
  "weixin.loginSucceeded": "[weixin] 로그인 성공 user={userId}",
  "weixin.loggedOut": "[weixin] 로그아웃했습니다.",
  "remote.service.online": "개인 채팅 원격 서비스가 시작되었습니다",
  "remote.service.state": "상태 디렉터리",
  "remote.service.allowed": "허용 사용자 수",
  "remote.service.transport": "연결 방식",
  "cli.setup.projectNotReady": "프로젝트를 아직 실행할 수 없습니다.",
  "cli.setup.createTemplate": "프로젝트 템플릿 생성 또는 복구: kitty start",
  "cli.setup.configFile": "구성 파일: {path}",
  "cli.setup.fillAndStart": "필수 값을 채운 뒤 Kitty를 시작하세요.",
  "cli.setup.originalError": "원래 오류: {error}",
  "cli.setup.apiKeyMissing": "provider API 키가 없습니다.",
  "cli.setup.setApiKey": "다음 파일에 KITTY_API_KEY 설정: {path}",
  "cli.setup.thenRestart": "그다음 Kitty를 다시 시작하세요.",
  "common.active": "활성",
  "common.undone": "되돌림",
  "status.label.pid": "프로세스 ID",
  "status.label.health": "상태",
  "status.label.deadline": "기한",
  "status.label.files": "파일",
  "interaction.queuedRestart": "수락된 입력은 지속 저장되었으며 재시작 후 계속됩니다.",
  "interaction.detachedRecovery": "현재 작업은 지속 저장되었으며 이 세션을 다시 열면 계속됩니다.",
  "web.pageTitle": "Kitty Agent",
  "web.common.back": "작업 공간으로 돌아가기",
  "web.common.save": "설정 저장",
  "web.common.sendTest": "연결 테스트",
  "web.common.testingConnection": "연결, 인증 정보 및 모델 목록을 확인하는 중입니다. 잠시 기다려 주세요…",
  "web.common.start": "시작",
  "web.common.stop": "중지",
  "web.common.github": "GitHub에서 Kitty 열기",
  "web.common.officialSite": "공식 사이트",
  "web.common.apiKeyPortal": "API Key 받기",
  "web.common.notConfigured": "설정되지 않음",
  "web.common.custom": "사용자 지정 설정",
  "web.common.requestFailed": "요청 실패({status})",
  "web.common.connectionSuccess": "연결 성공",
  "web.common.serviceState": "서비스 상태: {status}",
  "web.common.models": "모델 {count}개",
  "web.common.skills": "사용 가능한 Skill {count}개",
  "web.common.eventUpdated": "이벤트가 업데이트되었습니다",
  "web.common.eventDisconnected": "로컬 이벤트 연결이 끊겼습니다. 브라우저가 자동으로 다시 연결하며 서비스 상태에는 영향이 없습니다.",
  "web.status.stopped": "중지됨",
  "web.status.starting": "시작 중",
  "web.status.running": "실행 중",
  "web.status.stopping": "중지 중",
  "web.status.failed": "시작 실패",
  "web.status.unknown": "알 수 없는 상태",
  "web.login.waiting": "스캔 대기 중",
  "web.login.scanned": "스캔됨",
  "web.login.connected": "로그인됨",
  "web.login.failed": "로그인 실패",
  "web.workflow.basic": "기본 설정",
  "web.workflow.config": "언어 모델 설정",
  "web.workflow.media": "이미지 및 동영상 설정",
  "web.workflow.plugins": "플러그인 및 Skill 스위치",
  "web.workflow.other": "기타 설정",
  "web.workflow.weixin": "Weixin 원격 제어",
  "web.workflow.telegram": "Telegram 원격 제어",
  "web.workflow.skills": "Skills",
  "web.workflow.web": "Kitty 웹 제어",
  "web.workflow.loadingConfig": "현재 설정을 불러오는 중...",
  "web.workflow.loadingService": "서비스 상태를 불러오는 중...",
  "web.workflow.loadingSkills": "기능을 불러오는 중...",
  "web.workflow.basicNote": "언어 및 프로필",
  "web.workflow.configNote": "Provider 및 모델",
  "web.workflow.mediaNote": "이미지 및 동영상 생성",
  "web.workflow.mediaSummary": "독립적인 멀티모달 Provider 및 모델 설정",
  "web.workflow.pluginsNote": "기능 스위치",
  "web.workflow.otherNote": "고급 매개변수",
  "web.workflow.otherSummary": "컨텍스트, 파일 및 원격 프로토콜",
  "web.workflow.weixinNote": "Weixin 원격 제어",
  "web.workflow.telegramNote": "Telegram 원격 제어",
  "web.workflow.skillsNote": "읽기 전용",
  "web.workflow.webNote": "사용자 친화적 제어 화면",
  "web.workflow.webSummary": "웹 채팅 및 실행 제어",
  "web.workflow.guide": "모듈을 선택해 Kitty 설정 또는 관리를 계속하세요.",
  "web.config.description": "언어 모델 Provider, 자격 증명 및 추론 동작을 설정합니다.",
  "web.config.currentTitle": "현재 설정",
  "web.config.providerTitle": "Provider 설정",
  "web.config.providerHint": "프리셋은 권장 값을 채웁니다. 모든 필드는 직접 수정할 수 있습니다.",
  "web.config.validationTitle": "연결 테스트",
  "web.config.validationHint": "마지막으로 저장된 설정으로 모델 메타데이터를 읽습니다. 콘텐츠를 생성하거나 모델 Token을 소비하지 않습니다.",
  "web.config.settingsTitle": "모델 동작",
  "web.config.settingsHint": "사고 모드, 추론 강도, 출력 제한 및 사고 표시 설정은 저장 후 적용됩니다.",
  "web.config.extensionsTitle": "Extensions",
  "web.config.runtimeTitle": "실행 매개변수",
  "web.config.preset": "Provider 프리셋",
  "web.config.provider": "Provider",
  "web.config.model": "모델",
  "web.config.baseUrl": "Base URL",
  "web.config.apiKey": "API Key",
  "web.config.apiKeyHint": "현재 Provider의 키입니다. Provider를 전환한 뒤 선택한 Provider의 API Key를 입력하세요.",
  "web.config.currentLoaded": "현재 값 불러옴",
  "web.config.saved": "Kitty 설정을 저장했습니다.",
  "web.config.probeSuccess": "연결 성공 · {probe} · {models} · {baseUrl}",
  "web.media.description": "언어 모델과 독립적으로 이미지 및 동영상 생성을 설정합니다.",
  "web.media.currentTitle": "현재 미디어 설정",
  "web.media.providerTitle": "이미지 및 동영상 Provider",
  "web.media.providerHint": "이미지와 동영상은 미디어 자격 증명을 공유하며 언어 모델과는 독립적입니다.",
  "web.media.preset": "미디어 프리셋",
  "web.media.provider": "Provider",
  "web.media.imageModel": "이미지 모델",
  "web.media.videoModel": "동영상 모델",
  "web.media.baseUrl": "Base URL",
  "web.media.apiKey": "미디어 API Key",
  "web.media.apiKeyHint": "현재 키가 표시됩니다. 빈 값으로 저장하면 기존 값을 유지합니다.",
  "web.media.timeout": "요청 제한 시간(ms)",
  "web.media.pollInterval": "동영상 폴링 간격(ms)",
  "web.media.saved": "이미지 및 동영상 설정을 저장했습니다.",
  "web.media.validationTitle": "미디어 연결 테스트",
  "web.media.validationHint": "이미지나 동영상을 생성하지 않고 모델 엔드포인트만 확인합니다.",
  "web.media.studioTitle": "미디어 생성",
  "web.media.studioHint": "설정된 미디어 Provider로 이미지 또는 동영상 요청을 직접 실행합니다.",
  "web.media.imageTab": "이미지",
  "web.media.videoTab": "동영상",
  "web.media.prompt": "프롬프트",
  "web.media.size": "이미지 크기",
  "web.media.ratio": "이미지 비율",
  "web.media.videoSize": "동영상 프레임",
  "web.media.duration": "길이",
  "web.media.negativePrompt": "네거티브 프롬프트",
  "web.media.generateImage": "이미지 생성",
  "web.media.generateVideo": "동영상 생성",
  "web.media.stopPolling": "폴링 중지",
  "web.media.download": "다운로드",
  "web.media.videoId": "동영상 ID",
  "web.media.nextPoll": "다음 폴링",
  "web.media.generating": "이미지 생성 중…",
  "web.media.imageCompleted": "이미지 준비 완료",
  "web.media.videoCreating": "동영상 작업 생성 중…",
  "web.media.videoQueued": "동영상 대기 중",
  "web.media.videoWaiting": "다음 폴링 대기 중",
  "web.media.videoInProgress": "동영상 처리 중",
  "web.media.videoCompleted": "동영상 준비 완료",
  "web.basic.description": "현재 profile registry에서 인터페이스 언어와 Agent 프로필을 선택합니다.",
  "web.basic.saved": "기본 설정을 저장했습니다.",
  "web.plugins.description": "Kitty 플러그인을 켜고 끄며 이 프로젝트의 Skill을 확인합니다.",
  "web.plugins.saved": "플러그인 설정을 저장했습니다.",
  "web.other.description": "컨텍스트, 파일 제한 및 Weixin/Telegram 저빈도 프로토콜 설정을 조정합니다.",
  "web.other.saved": "기타 설정을 저장했습니다.",
  "web.weixin.description": "Kitty를 사용할 사용자를 설정하고 QR 코드로 로그인한 뒤 로컬 서비스를 시작합니다.",
  "web.weixin.allowedTitle": "사용자 허용 목록",
  "web.weixin.userId": "사용자 ID",
  "web.weixin.usersPlaceholder": "여러 ID는 쉼표로 구분",
  "web.weixin.saved": "허용 사용자를 저장했습니다.",
  "web.weixin.loginTitle": "Weixin 로그인",
  "web.weixin.loginHint": "QR 코드와 인증 정보는 이 로컬 프로젝트에만 속합니다.",
  "web.weixin.generateQr": "QR 코드 생성",
  "web.weixin.logout": "로그아웃",
  "web.weixin.startTitle": "서비스 시작",
  "web.weixin.startHint": "시작 후 메시지와 Agent 활동이 아래에 표시됩니다.",
  "web.weixin.streamEmpty": "Weixin 서비스 이벤트가 여기에 표시됩니다",
  "web.weixin.waitingLogin": "Weixin QR 로그인 대기 중",
  "web.weixin.credentialsCleared": "Weixin 인증 정보를 삭제했습니다",
  "web.weixin.qrGenerating": "QR 코드 생성 중...",
  "web.weixin.connected": "Weixin 인증 정보가 연결되었습니다",
  "web.weixin.qrAlt": "Weixin 로그인 QR 코드",
  "web.telegram.description": "Bot Token과 허용 사용자를 저장하고 Bot 신원을 확인한 뒤 서비스를 시작합니다.",
  "web.telegram.botTitle": "Bot 설정",
  "web.telegram.token": "Bot Token",
  "web.telegram.tokenHint": "`.kitty/.env`의 현재 값입니다. 빈 값으로 저장하면 기존 Token을 유지합니다.",
  "web.telegram.users": "허용 사용자 ID",
  "web.telegram.usersPlaceholder": "여러 ID는 쉼표로 구분",
  "web.telegram.saved": "Telegram 설정을 저장했습니다.",
  "web.telegram.verifyTitle": "Bot Token 확인",
  "web.telegram.verifyHint": "Telegram `getMe`를 호출하고 성공하면 Bot 사용자 이름을 표시합니다.",
  "web.telegram.startTitle": "서비스 시작",
  "web.telegram.startHint": "시작 후 Telegram에서 메시지를 보내면 전체 활동이 아래에 표시됩니다.",
  "web.telegram.streamEmpty": "Telegram 서비스 이벤트가 여기에 표시됩니다",
  "web.telegram.probeSuccess": "연결 성공 · @{identity}",
  "web.skills.description": "이 프로젝트에서 발견할 수 있는 기능을 읽습니다. 브라우저는 Skill 파일을 수정하지 않습니다.",
  "web.skills.empty": "이 프로젝트에서 사용할 수 있는 Skill이 없습니다",
  "web.skills.source": "Skill 소스",
  "web.stream.inbound": "메시지 수신",
  "web.stream.status": "서비스",
  "web.stream.reasoning": "생각",
  "web.stream.assistant": "응답 중",
  "web.stream.final": "최종 응답",
  "web.stream.toolCall": "도구 호출",
  "web.stream.toolProgress": "도구 실행 중",
  "web.stream.toolResult": "도구 결과",
  "web.stream.toolError": "도구 오류",
  "web.stream.error": "오류",
  "web.shell.connected": "연결됨",
  "web.shell.disconnected": "연결이 종료되었습니다",
  "web.shell.thinking": "생각 중",
  "web.shell.stopped": "중지됨",
  "web.shell.inputPlaceholder": "메시지 입력",
  "web.shell.send": "보내기",
  "web.shell.stop": "중지",
  "web.shell.empty": "Kitty에게 작업을 맡기세요.",
  "web.shell.reasoning": "생각 중",
  "web.shell.user": "나",
  "web.shell.assistant": "Kitty",
  "web.shell.toolUpdating": "{target} 업데이트 중",
  "web.shell.toolWriting": "파일 작성 중",
  "web.shell.toolReading": "{target} 읽는 중",
  "web.shell.toolReadingGeneric": "파일 읽는 중",
  "web.shell.toolRunning": "{command} 실행 중",
  "web.shell.toolRunningGeneric": "명령 실행 중",
  "web.shell.toolCalling": "{name} 호출 중",
  "web.shell.toolUpdated": "{target} 업데이트됨",
  "web.shell.toolCreated": "{target} 생성됨",
  "web.shell.toolRead": "{target} 읽음",
  "web.shell.toolDone": "도구 실행 완료",
  "web.shell.toolFailed": "도구 실행 실패",
  "web.shell.toolPlan": "계획 업데이트 · {completed}/{total} 완료",
  "web.shell.commandDone": "명령 실행 완료",
  "web.shell.commandFailed": "명령 실행 실패",
  "web.runtime.locale": "표시 언어",
  "web.runtime.profile": "Agent 프로필",
  "web.runtime.thinking": "사고 모드",
  "web.runtime.reasoningEffort": "추론 강도",
  "web.runtime.maxOutputTokens": "최대 출력 토큰",
  "web.runtime.contextWindowMessages": "컨텍스트 메시지 수",
  "web.runtime.maxContextChars": "최대 컨텍스트 문자 수",
  "web.runtime.contextSummaryChars": "컨텍스트 요약 문자 수",
  "web.runtime.maxReadBytes": "파일 읽기 한도(바이트)",
  "web.runtime.projectDocMaxBytes": "프로젝트 문서 한도(바이트)",
  "web.runtime.commandStallTimeoutMs": "명령 무출력 제한 시간(ms)",
  "web.runtime.showReasoning": "생각 과정 표시",
  "web.runtime.telegramApiBaseUrl": "Telegram API 기본 URL",
  "web.runtime.telegramProxyUrl": "Telegram 프록시 URL",
  "web.runtime.telegramPollingTimeoutSeconds": "Telegram 폴링 제한 시간(초)",
  "web.runtime.telegramPollingLimit": "Telegram 폴링 개수",
  "web.runtime.telegramPollingRetryBackoffMs": "Telegram 폴링 재시도 간격(ms)",
  "web.runtime.telegramMessageChunkChars": "Telegram 메시지 분할 문자 수",
  "web.runtime.telegramTypingIntervalMs": "Telegram 입력 상태 간격(ms)",
  "web.runtime.telegramDeliveryMaxRetries": "Telegram 전송 재시도 횟수",
  "web.runtime.telegramDeliveryBaseDelayMs": "Telegram 전송 기본 지연(ms)",
  "web.runtime.telegramDeliveryMaxDelayMs": "Telegram 전송 최대 지연(ms)",
  "web.runtime.weixinBaseUrl": "Weixin iLink 기본 URL",
  "web.runtime.weixinCdnBaseUrl": "Weixin CDN 기본 URL",
  "web.runtime.weixinPollingTimeoutMs": "Weixin 폴링 제한 시간(ms)",
  "web.runtime.weixinPollingRetryBackoffMs": "Weixin 폴링 재시도 간격(ms)",
  "web.runtime.weixinMessageChunkBytes": "Weixin 메시지 분할 크기(바이트)",
  "web.runtime.weixinTypingIntervalMs": "Weixin 입력 상태 간격(ms)",
  "web.runtime.weixinQrTimeoutMs": "Weixin QR 제한 시간(ms)",
  "web.runtime.weixinRouteTag": "Weixin 라우트 태그",
  "web.locale.zh-CN": "중국어 간체",
  "web.locale.en": "영어",
  "web.locale.ja": "일본어",
  "web.locale.ko": "한국어",
  "web.option.enabled": "사용",
  "web.option.disabled": "사용 안 함",
  "web.option.xhigh": "최고",
  "web.option.high": "높음",
  "web.option.medium": "보통",
  "web.option.low": "낮음",
  "web.option.minimal": "최소",
  "web.option.true": "예",
  "web.option.false": "아니요",
  "web.extension.todo": "세션 체크리스트와 진행 상황 표시.",
  "web.extension.scheduler": "모델 폴링 없이 지속되는 알림과 로컬 명령 일정.",
  "web.extension.worktree": "Git worktree 발견과 수명 주기 관리.",
  "web.extension.network": "HTTP 요청, 검사, 다운로드, 추적, OpenAPI 확인.",
  "web.extension.media": "이미지를 생성하고 video_id로 동영상을 생성, 조회, 저장합니다.",
  "web.extension.background": "수명 주기와 출력을 지속 기록하는 백그라운드 명령.",
  "web.extension.documents": "DOCX 및 텍스트 PDF 범위 읽기와 Word 문서 작성.",
  "web.extension.skills": "프로젝트 Skill 발견과 명시적 로드.",
  "web.event.toolFailed": "{name} 실행 실패",
  "web.event.toolProgress": "{name} 인수 수신 중",
  "web.event.writeDocument": "문서 쓰기",
  "web.event.changeFile": "파일 변경",
  "web.event.readDocument": "문서 읽기",
  "web.event.readFile": "파일 읽기",
  "web.event.fromOffset": "{offset}부터",
  "web.event.runCommand": "명령 실행",
  "web.event.directory": "디렉터리: {path}",
  "web.event.runTool": "도구 실행 · {name}",
  "web.event.fileCreated": "파일 생성됨",
  "web.event.fileUpdated": "파일 업데이트됨",
  "web.event.documentCreated": "문서 생성됨",
  "web.event.documentUpdated": "문서 업데이트됨",
  "web.event.readComplete": "읽기 완료",
  "web.event.commandFailed": "명령 실행 실패",
  "web.event.commandComplete": "명령 실행 완료",
  "web.event.planUpdated": "Plan 업데이트 · {completed}/{total}",
  "web.event.toolComplete": "{name} 실행 완료",
  "web.event.missingTarget": "대상이 지정되지 않음",
} satisfies MessageCatalog;
